// ProductPage.js
import React, { useEffect, useRef } from 'react';
import { Link } from "react-router-dom";

import WebsiteNavbar from './lib/html/WebsiteNavbar';
import WebsiteFooter from './lib/html/WebsiteFooter';
import ScrollingSchools from './lib/html/ScrollingSchools';
import SisList from './lib/html/SisList';

import '../../css/home_page.css';


import magnetboard from './lib/images/magnetboard.png';
import stepbystep from './lib/images/step-by-step-screens.png';
import constraints from './lib/images/constraint-screen.png';
import conflicts from './lib/images/conflicts-screen.png';
import algorithms from './lib/images/powerful-algorithms.png';
import livereports from './lib/images/live-reports.png';
import fileimport from './lib/images/file-import.png';
import buildaschedule from './lib/images/build-a-schedule.png';
import exportfile from './lib/images/export-file.png';

export default function SolutionsMSPage() {
	let featuresRef = useRef();

	const scrollTo = (ref) => {
		if (ref && ref.current /* + other conditions */) {
			ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}
	}

	useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        }
      });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

    return () => observer.disconnect();
	}, []);

  return (
	<>
	 <div id="homepage-content">
		<WebsiteNavbar></WebsiteNavbar>
      {/* HERO */}
      <section className="product-hero light-gray">
        <div className="product-hero-inner grid-mobilize">
          <div className="product-hero-copy">
            <h1 className='dark-blue-text'>MASTER SCHEDULING FOR</h1>
			      <h1 id='product-hero-school-type'>MIDDLE SCHOOLS</h1>
            <p>Build, adjust, and optimize middle school master schedules with confidence —
              no spreadsheets, no guesswork, no stress.</p>
            <div className="product-hero-cta grid-mobilize">
              <Link className="product-hero-cta-btn" to="/contact">Request a Demo</Link>
              <div className="product-hero-cta-link" onClick={() => scrollTo(featuresRef)}>See How It Works</div>
            </div>
          </div>
          <div className="product-hero-media">
            <div className="media-placeholder">
				<img src={magnetboard} alt='Middle school magnetboard preview'/>
			</div>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
		<section className="product-trust-bar light-gray">
      <ScrollingSchools>s</ScrollingSchools>
		</section>

      {/* FEATURES */}
      <section id="features" className="product-features" ref={featuresRef}>
        <h2>Everything You Need to Build a<br></br> Better Schedule</h2>
        <div className="feature-grid">
          <div className="feature-card fade-up grid-mobilize">
            <div className="feature-media">
              <img src={stepbystep} alt='Guided setup workflow preview'/>
            </div>
            <div>
              <h3>Guided Setup</h3>
              <p>Step-by-step workflows guide you through even the most complex schedules.</p>
            </div>
          </div>
          <div className="feature-card feature-card-opposite fade-up grid-mobilize">
            <div>
              <h3>Intuitive Constraints</h3>
              <p>Easily set the rules and restrictions you have on your schedule.</p>
            </div>
            <div className="feature-media">
              <img src={constraints} alt='Scheduling constraints screen preview'/>
            </div>
          </div>
          <div className="feature-card fade-up grid-mobilize">
            <div className="feature-media">
              <img src={conflicts} alt='Conflict resolution screen preview'/>
            </div>
            <div>
              <h3>Conflict Visibility</h3>
              <p>Instantly see, understand, and resolve conflicts without starting over.</p>
            </div>
          </div>
          <div className="feature-card feature-card-opposite fade-up grid-mobilize">
            <div>
              <h3>Powerful Automation</h3>
              <p>Our scheduling algorithms build optimized schedules FAST, so you can iterate quickly.</p>
            </div>
            <div className="feature-media">
              <img src={algorithms} alt='Automated scheduling preview'/>
            </div>
          </div>
          <div className="feature-card fade-up grid-mobilize">
            <div className="feature-media">
              <img src={livereports} alt='Live scheduling reports preview'/>
            </div>
            <div>
              <h3>Real-Time Editing</h3>
              <p>Edit schedules live and immediately see downstream impacts.</p>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="product-how">
        <h2>How It Works</h2>
        <div className="how-steps">
          <div className="how-step">
            <span>1</span>
              <img src={fileimport} alt='Import data step illustration'/>
            <h4>Import Your Data</h4>
            <p>We pull data from your SIS system (courses, teachers, rooms, constraints)</p>
          </div>
          <div className="how-step">
            <span>2</span>
              <img src={buildaschedule} alt='Build schedule step illustration'/>
            <h4>Build your Schedule (FAST)</h4>
            <p>Use Edario's Turbo-tax-like screens to build your schedule</p>
          </div>
          <div className="how-step">
            <span>3</span>
              <img src={exportfile} alt='Export schedule step illustration'/>
            <h4>Refine & Export</h4>
            <p>Make adjustments and export directly back to your SIS. No manual section creation required!</p>
          </div>
        </div>
      </section>
      <div className='homepage-banner'>
        <SisList></SisList>
      </div>
		<WebsiteFooter></WebsiteFooter>
    </div>
	</>
  );
}
